// good_english_data_1a_l02.js
// Good English 1A L02 - Fun at the Beach
// 路由：/ge/1a/l02
//
// 音频规则：
// - 非最后一页: end = 下一个 start - 1
// - 最后一页: 无 end（播放到音频结尾）

const MEDIA_BASE = '/media/good-english/1a/l02';
const V = 'v1';

export const dataGoodEnglish1aL02 = {
  id: '1a-l02',
  title: 'L02 Fun at the Beach',
  mediaBase: MEDIA_BASE,
  audio: `${MEDIA_BASE}/story.mp3?${V}`,
  pages: [
    { image: `${MEDIA_BASE}/page1.png?${V}`, text: 'Dad and Mum.',                         start: 20, end: 25 },  // 26-1
    { image: `${MEDIA_BASE}/page2.png?${V}`, text: 'Mum and Dad. Kipper, Chip and Biff.',       start: 26, end: 36 },  // 37-1
    { image: `${MEDIA_BASE}/page3.png?${V}`, text: 'Kipper, Biff and Dad. Mum, Chip and Floppy.', start: 37, end: 50 },  // 51-1
    { image: `${MEDIA_BASE}/page5.png?${V}`, text: 'Chip, Biff and Kipper. Dad and Floppy.', start: 51, end: 62 },  // 63-1
    { image: `${MEDIA_BASE}/page6.png?${V}`, text: 'Oh, floppy.',                          start: 63 },           // 最后页，无 end
  ],
};
